import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { ModalContext } from '../../provider/ModalProvider';
import { IoCloseSharp } from 'react-icons/io5';

import { d_flex_center, dir_column, CloseButton } from '../../styles/common';
import { styled, Box } from '@mui/material';
interface StyledModalAlertWrapProps {
  visible: boolean;
}

const StyledModalAlertWrap = styled(Box)<StyledModalAlertWrapProps>(props => ({
  backgroundColor: 'transparent',
  borderRadius: '4px',
  overflow: 'hidden',
  position: 'fixed',
  top: '15.5%',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1301,
  opacity: props.visible ? 1 : 0,
  visibility: props.visible ? 'visible' : 'hidden',
  transition: 'opacity 0.5s, visibility 0.5s',
  paddingRight: '2rem',
}));

const StyledModalAlert = styled(Box)(props => ({
  position: 'relative',
  minWidth: 'calc(100% + 2rem)',
  maxWidth: '480px',
  minHeight: '20px',
  borderRadius: '30px',
  padding: '6px 16px',
  backgroundColor: '#404040',
  [props.theme.breakpoints.up('xxl')]: {
    fontSize: '1.1rem',
  },
  [props.theme.breakpoints.down('xxl')]: {
    fontSize: '1.2rem',
  },
  whiteSpace: 'pre-wrap',
}));

const StyledTitle = styled(Box)(props => ({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  margin: '0.4rem 0 0.4rem 0',
  [props.theme.breakpoints.up('xxl')]: {
    fontSize: '0.95rem',
  },
  [props.theme.breakpoints.down('xxl')]: {
    fontSize: '1.2rem',
  },
  lineHeight: '1.5',
  color: '#fff !important',
  caretColor: '#fff !important',
  ...d_flex_center,
  ...dir_column,

  '.sub_title': {
    fontWeight: '300',
    fontSize: '1.1rem',
  },
}));

function ModalAlert() {
  const { modal_alert } = useContext(ModalContext);
  const [isVisible, setIsVisible] = useState(modal_alert.data.visible);

  useEffect(() => {
    if (modal_alert.data.visible) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [modal_alert.data.visible]);

  return isVisible ? (
    <StyledModalAlertWrap visible={modal_alert.data.visible} id='modal_alert'>
      <StyledModalAlert>
        <StyledTitle dangerouslySetInnerHTML={{ __html: modal_alert.data.title }}></StyledTitle>
        {modal_alert.data.timeout ? null : modal_alert.data.use_close_button === false ? null : (
          <CloseButton
            sx={{
              top: '50%',
              transform: 'translateY(-50%)',
              right: '0.625rem',
              width: '1.625rem',
              height: '1.625rem',
              svg: { width: '1.375rem', height: '1.375rem', color: '#fff' },
            }}
            onClick={() => modal_alert.closeModalAlert()}
          >
            <IoCloseSharp />
          </CloseButton>
        )}
      </StyledModalAlert>
    </StyledModalAlertWrap>
  ) : null;
}

export default ModalAlert;
